import { render } from "./EditWorkerComponent.vue?vue&type=template&id=8ca2023c&scoped=true"
import script from "./EditWorkerComponent.vue?vue&type=script&lang=js"
export * from "./EditWorkerComponent.vue?vue&type=script&lang=js"

import "./EditWorkerComponent.vue?vue&type=style&index=0&id=8ca2023c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca2023c"]])

export default __exports__